export default "__VITE_ASSET__Bw5U08SL__"